import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ListDetailsCard from '../../shared/ListDetailsCard'
import {
  getPatientDetails,
  getVisitDetails,
  getPractitionerDetails,
  ServiceItemColumns
} from '../../constants/VisitsConstants'
import PageHeader from '../../shared/PageHeader'
import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa'
import CustomTable from '../../shared/CustomTable'
import CardHeading from '../../shared/CardHeading'

const VisitHistoryDetailPage = () => {
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const visitData = location?.state?.visitData
  const navigate = useNavigate()
  console.log(visitData)

  return (
    <div className='main-page-container !overflow-auto scrollbar'>
      <PageHeader
        title={t("Visit Details")}
        iconSize={20}
        Icon={i18n.language == 'en' ? FaArrowCircleLeft : FaArrowCircleRight}
        onIconClick={() => navigate(-1)}
      ></PageHeader>
      <ListDetailsCard
        title='Patient Information'
        listData={getPatientDetails(visitData,t)}
      />
      <ListDetailsCard
        title='Visit Information'
        listData={getVisitDetails(visitData,t)}
      />
      <div className='w-full h-full mt-5'>
        <CardHeading title={t("Visit Items")} />
        <div className='mt-2'>
          <CustomTable
            data={visitData?.items}
            columns={ServiceItemColumns(t)}
          />
        </div>
      </div>
    </div>
  )
}

export default VisitHistoryDetailPage
